module.exports = __webpack_public_path__ + "images/142e0ae8.img_kor_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/img_kor_2.jpg
// module id = 350
// module chunks = 0